var map = {
	"./": 468,
	"./development": 1401,
	"./development.js": 1401,
	"./index": 468,
	"./index.js": 468,
	"./preprod": 1402,
	"./preprod.js": 1402,
	"./production": 1382,
	"./production.js": 1382,
	"./staging": 1403,
	"./staging.js": 1403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3414;